import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import api from '../utils/api';

export default function RetireCredits() {
  const navigate = useNavigate();
  const [tokens, setTokens] = useState([]);
  const [form, setForm] = useState({ token_class_id: '', quantity: 1, beneficiary_name: '', retirement_reason: 'Voluntary claim', claim_text: '' });

  useEffect(() => {
    api.get('/custody/wallet').then((r) => {
      const rows = r.data.tokens || [];
      setTokens(rows);
      if (rows[0]) setForm((prev) => ({ ...prev, token_class_id: rows[0].token_class_id }));
    }).catch((error) => toast.error(error.response?.data?.message || 'Failed to load token balances'));
  }, []);

  const retire = async (e) => {
    e.preventDefault();
    try {
      const res = await api.post('/tokenization/retire', { ...form, quantity: Number(form.quantity) });
      toast.success('Credits retired');
      navigate(`/retirements/${res.data.retirement.id}`);
    } catch (error) {
      toast.error(error.response?.data?.message || 'Retirement failed');
    }
  };

  return (
    <div className="page-shell page-stack">
      <section className="surface-panel glow-surface" style={{ padding: '1.5rem' }}>
        <div className="section-tag">Retirement</div>
        <h1 className="section-title">Retire tokenized credits</h1>
      </section>

      <section className="surface-panel" style={{ padding: '1.5rem' }}>
        <form onSubmit={retire} style={{ display: 'grid', gap: '0.85rem' }}>
          <select className="form-select" value={form.token_class_id} onChange={(e) => setForm({ ...form, token_class_id: e.target.value })}>
            {tokens.map((token) => <option key={token.token_class_id} value={token.token_class_id}>{token.symbol} · avail {token.available_qty}</option>)}
          </select>
          <input className="form-input" type="number" value={form.quantity} onChange={(e) => setForm({ ...form, quantity: e.target.value })} placeholder="Quantity" />
          <input className="form-input" value={form.beneficiary_name} onChange={(e) => setForm({ ...form, beneficiary_name: e.target.value })} placeholder="Beneficiary name" />
          <input className="form-input" value={form.retirement_reason} onChange={(e) => setForm({ ...form, retirement_reason: e.target.value })} placeholder="Retirement reason" />
          <textarea className="form-textarea" rows={3} value={form.claim_text} onChange={(e) => setForm({ ...form, claim_text: e.target.value })} placeholder="Claim text" />
          <button className="btn btn-primary">Retire credits</button>
        </form>
      </section>
    </div>
  );
}
